import { Component, OnInit } from '@angular/core';

import {
    DOC_TYPES, FoundDocument, L2_PROCESSES, PROCESS_MAP, SOURCE_KEYS, TAXONOMY, landscapeLabel, sourceName
} from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

/** History, packs, process map, taxonomy, feedback log, help and settings pages. All data comes from the API. */
@Component({
    selector: 'df-info-pages',
    templateUrl: './df-info-pages.component.html',
    styleUrls: ['./df-info-pages.component.scss'],
    standalone: false
})
export class DfInfoPagesComponent implements OnInit {
    public readonly docTypes = DOC_TYPES as Record<string, (typeof DOC_TYPES)[keyof typeof DOC_TYPES]>;
    public readonly landscapeLabel = landscapeLabel;
    public readonly l2 = L2_PROCESSES;
    public readonly processMap = PROCESS_MAP;
    public readonly taxonomy = TAXONOMY;

    constructor(public df: DocumentFinderService) {}

    public ngOnInit(): void {
        this.df.loadHistory();
        this.df.loadPacks();
    }

    public get defaultSources(): string {
        return SOURCE_KEYS.map(sourceName).join(' · ') || '—';
    }

    public get excludedAll(): FoundDocument[] {
        return this.df.documents.filter(d => this.df.decisions[d.id] === 'exc');
    }

    public openSearch(query: string): void {
        this.df.query = query;
        this.df.navigate('search');
    }
}
